import React, { useState, useEffect, useMemo, lazy, Suspense, createContext } from "react";
import { Route, Routes, BrowserRouter, Navigate } from "react-router-dom";
import { useMediaQuery, useTheme } from "@mui/material";
import { ROUTINGDATA } from "./components/ROUTINGDATA";
import SeoHelmet from "./components/SeoHelmet";
import useAxios from "./api/useAxios";
import "./App.css";
import JobSeekerRegForm from "./components/skeleton/jobseeker/JobSeekerRegForm";
import PostedJob from "./components/skeleton/PostJob/PostedJob"

// Dynamic imports with React.lazy for Code Splitting
const Main = lazy(() => import("./components/Main"));
const Thankyou = lazy(() => import("./components/ThankYouForm/Thankyou"));
const Login = lazy(() => import("./components/login/Login"));
const ForgotPassword = lazy(() => import("./components/login/forgot password/ForgotPassword"));
const ForgotPW2 = lazy(() => import("./components/login/forgot password/ForgotPW2"));
const ChangePassword = lazy(() => import("./components/login/change password/ChangePassword"));
const OtpforPassword = lazy(() => import("./components/login/forgot password/OtpforPassword"));
const Employer = lazy(() => import("./components/skeleton/employer/Employer"));
const AdminPanel = lazy(() => import("./components/admin-panel/AdminPanel"));
const Dashboard = lazy(() => import("./components/admin-panel/admin-components/Dashboard"));
const EmployerData = lazy(() => import("./components/admin-panel/admin-components/EmployerData"));
const SeekerData = lazy(() => import("./components/admin-panel/admin-components/SeekerData"));
const VolunteerData = lazy(() => import("./components/admin-panel/admin-components/VolunteerData"));
const UserData = lazy(() => import("./components/admin-panel/admin-components/UserData"));
const UpdateRegisterForm = lazy(() => import("./components/skeleton/UpdateComponent/UpdateProfile/UpdateRegisterForm"));
const LandingPage = lazy(() => import("./components/Landingpage/Landingpage"));
const EmployerUpdate = lazy(() => import("./components/skeleton/EmployerUpdateProfile/EmployerUpdate"));
const NeedSupport = lazy(() => import("./components/skeleton/UpdateComponent/JobSeekerComponent/NeedSupport"));
const BankDetails = lazy(() => import("./components/skeleton/UpdateComponent/JobSeekerComponent/BankDetails"));
const SeekerNeedSupport = lazy(() => import("./components/admin-panel/admin-components/SeekerFamilyDetails/SeekerNeedSupport"));
const PostJob = lazy(() => import("./components/skeleton/PostJob/PostJob"));
const MPconstituencyPanel = lazy(() => import("./components/Dashboards/MPconstituency/MPconsitiuencyPanel"));
const MPDashboard = lazy(() => import("./components/Dashboards/MPconstituency/Components/MPDashboard"));
const AppliedSeekers = lazy(() => import("./components/skeleton/PostJob/AppliedSeekers"));
const RecommendedJob = lazy(() => import("./components/skeleton/UpdateComponent/JobSeekerComponent/RecommendedJob"));
const FullFamilyDetails = lazy(() => import("./components/admin-panel/admin-components/SeekerFamilyDetails/FullFamilyDetails"));
const MLAconstituency1 = lazy(() => import("./components/Dashboards/MPconstituency/Components/MLAconstituency1"));
const SeekersApplied = lazy(() => import("./components/skeleton/PostJob/SeekersApplied"));
const VerifierPanel = lazy(() => import("./components/Dashboards/Verifier/VerifierPanel"));
const MLAconsitiuencyPanel = lazy(() => import("./components/Dashboards/MLAconsitituency/MLAconstituencyPanel"));
const VerifierDashboard = lazy(() => import("./components/Dashboards/Verifier/Components/VerifierDashboard"));
const VerifierFullDetails = lazy(() => import("./components/Dashboards/Verifier/Components/VerifierFullDetails"));
const Searchpageforlocalservices = lazy(() => import("./components/Landingpage/Searchpage/Searchpageforlocalservices"));
const AppliedJobs = lazy(() => import("./components/skeleton/UpdateComponent/JobSeekerComponent/AppliedJobs"));
const MLASeekers = lazy(() => import("./components/Dashboards/MLAconsitituency/components/MLASeekers"));
const MPMLAneedSupport = lazy(() => import("./components/Dashboards/MPconstituency/Components/MPMLAneedSupport"));
const MLAneedSupport = lazy(() => import("./components/Dashboards/MLAconsitituency/components/MLAneedSupport"));
const MLAdashboard = lazy(() => import("./components/Dashboards/MLAconsitituency/components/MLAdashboard"));
const MLAsupported = lazy(() => import("./components/Dashboards/MLAconsitituency/components/MLAsupported"));
const PageNotFound = lazy(() => import("./components/skeleton/PageNotFound/PageNotFound"));
const PaymentSuccess = lazy(() => import("./components/skeleton/Subscriptions/Paymentmessage"));
const Volunteer = lazy(() => import("./components/skeleton/VolunteerForm/Volunteer"));
const VolunteerPanel = lazy(() => import("./components/Dashboards/Volunteer/VolunteerPanel"));
const VolunteerDashboard = lazy(() => import("./components/Dashboards/Volunteer/components/VolunteerDashboard"));
const VolunteerAllDetails = lazy(() => import("./components/Dashboards/Volunteer/components/VolunteerAllDetails"));
const VolunteerNeedSupport = lazy(() => import("./components/Dashboards/Volunteer/components/VolunteerNeedSupport"));
const VolunteerShortList = lazy(() => import("./components/Dashboards/Volunteer/components/VolunteerShortList"));
const MPMLAShortList = lazy(() => import("./components/Dashboards/MPconstituency/Components/MPMLAShortList"));
const ServiceSubscription = lazy(() => import("./components/skeleton/Local_jobs_and_services/ServiceSubscription/Servicesubscription"));
const MentorRegistration = lazy(() => import("./components/skeleton/Mentor/MentorRegistration"));
const MPAllData = lazy(() => import("./components/Dashboards/MPconstituency/Components/Master/MPAllData"));
const MPNeedSupport = lazy(() => import("./components/Dashboards/MPconstituency/Components/Master/MPNeedSupport"));
const MPShortList = lazy(() => import("./components/Dashboards/MPconstituency/Components/Master/MPShortList"));
const MPMLAsupported = lazy(() => import("./components/Dashboards/MPconstituency/Components/MPMLAsupported"));
const MPsupported = lazy(() => import("./components/Dashboards/MPconstituency/Components/Master/MPsupported"));
const VolunteerSupported = lazy(() => import("./components/Dashboards/Volunteer/components/VolunteerSupported"));
const Landingpagecontext = lazy(() => import("./components/Landingpage/landingpagecontext/Landingpagecontext"));
const LandingpageContactus = lazy(() => import("./components/Landingpage/landingpagecontext/LandingpageContactus"));
const LocalJobRegForm = lazy(() => import("./components/skeleton/Local_jobs_and_services/LocalJob/LocalJobRegForm"));
const LocalServiceProviderForm = lazy(() => import("./components/skeleton/Local_jobs_and_services/LocalServiceProvider/LocalServiceProviderForm"));
const LocalServicesForm = lazy(() => import("./components/skeleton/Local_jobs_and_services/LocalServices/LocalServicesForm"));
const Auditing = lazy(() => import("./components/skeleton/PostJob/Auditing"));
const ThankYouPageForLocal = lazy(() => import("./components/ThankYouForm/ThankYouPageForLocal"));
const MentorAboutUs = lazy(() => import("./components/skeleton/Mentor/MentorAboutUs"));
const MentorAdminData = lazy(() => import("./components/admin-panel/admin-components/MentorAdminData"));
const MentorUpdateForm = lazy(() => import("./components/skeleton/Mentor/MentorUpdateForm"));
const Subscribe = lazy(() => import("./components/skeleton/Subscriptions/Subscribe"));
const AdminSettings = lazy(() => import("./components/admin-panel/admin-settings/AdminSettings"));
const ProviderPanel = lazy(() => import("./components/Dashboards/LocalJobsProvider/ProviderPanel"));
const ProviderDashboard = lazy(() => import("./components/Dashboards/LocalJobsProvider/Components/ProviderDashboard"));
const AdminApproval = lazy(() => import("./components/admin-panel/admin-settings/components/AdminApproval"));
const AdminEmployerSettings = lazy(() => import("./components/admin-panel/admin-settings/components/AdminEmployerSettings"));
const Advertisement = lazy(() => import("./components/Landingpage/Advertisement/Advertisement"));
const ServiceProvider = lazy(() => import("./components/admin-panel/admin-components/ServiceProvider"));
const LocalServiceLogin = lazy(() => import("./components/skeleton/Local_jobs_and_services/LocalServices/LocalServiceLogin"));
const LocalServicePanel = lazy(() => import("./components/skeleton/Local_jobs_and_services/LocalServices/LocalServicePanel"));
const AdvertisePayment = lazy(() => import("./components/Landingpage/Advertisement/AdvertisePayment"));
const BecomeAPartner = lazy(() => import("./components/skeleton/Become_a_Partner_investor/BecomeAPartner"));
const TermsAndCondition = lazy(() => import("./components/termsAndCondition/TermsAndCondition"));
const PrivacyPolicy = lazy(() => import("./components/termsAndCondition/PrivacyPolicy"));
const PurchasePolicy = lazy(() => import("./components/termsAndCondition/PurchasePolicy"));
const RefundPolicy = lazy(() => import("./components/termsAndCondition/RefundPolicy"));
const DeliveryPolicy = lazy(() => import("./components/termsAndCondition/DeliveryPolicy"));
const PricingPolicy = lazy(() => import("./components/termsAndCondition/PricingPolicy"));
const BecomeAInvestor = lazy(() => import("./components/skeleton/Become_a_Partner_investor/BecomeAInvestor"));
const AdminAdvertisementSettings = lazy(() => import("./components/admin-panel/admin-settings/components/AdminAdvertisementSettings"));
const AdminPartners = lazy(() => import("./components/admin-panel/admin-components/AdminPartners"));
const AdminInvestors = lazy(() => import("./components/admin-panel/admin-components/AdminInvestors"));
const PartnerPanel = lazy(() => import("./components/Dashboards/partner/PartnerPanel"));
const PartnerDashboard = lazy(() => import("./components/Dashboards/partner/components/PartnerDashboard"));
const ImageUploadSettings = lazy(() => import("./components/admin-panel/admin-settings/components/ImageUploadSettings"));
const AdminImageUpload = lazy(() => import("./components/admin-panel/admin-settings/components/AdminImageUpload"));
const AdminAllJobs = lazy(() => import("./components/admin-panel/admin-components/AdminAllJobs"));
const CompanyList = lazy(() => import("./components/skeleton/Companies/CompanyList"));
const CompanyDetails = lazy(() => import("./components/skeleton/Companies/CompanyDetails"));
const SeekerVelaivendumSupport = lazy(() => import("./components/admin-panel/admin-components/SeekerVelaivendumSupport"));
const AdPaymentSettings = lazy(() => import("./components/admin-panel/admin-settings/components/AdPaymentSettings"));
const InvestorDashboard = lazy(() => import("./components/Dashboards/investor/component/InvestorDashboard"));
const InvestorPanel = lazy(() => import("./components/Dashboards/investor/Investorpanel"));
const InvestorAllocatedPincodes = lazy(() => import("./components/Dashboards/investor/component/InvestorAllocatedPincodes"));
const InvestorCreatePincodeFranchiser = lazy(() => import("./components/Dashboards/investor/component/InvestorCreatePincodeFranchiser"));
const InvestorPincodewisePayment = lazy(() => import("./components/Dashboards/investor/component/InvestorPincodewisePayment"));
const InvestorTodayCollectionReport = lazy(() => import("./components/Dashboards/investor/component/InvestorTodayCollectionReport"));
const InvestorMasterMyCoustomer = lazy(() => import("./components/Dashboards/investor/component/InvestorMasterMyCoustomer"));
const InvestorMasterMyLeads = lazy(() => import("./components/Dashboards/investor/component/InvestorMasterMyLeads"));
const InvestorMyEmployer = lazy(() => import("./components/Dashboards/investor/component/InvestorMyEmployer"));
const PaymentVendors = lazy(() => import("./components/admin-panel/admin-settings/components/PaymentVendors"));
const BuyDatabaseAccess = lazy(() => import("./components/skeleton/EmployerDatabaseAccess/BuyDatabaseAccess"));
const ViewDatabase = lazy(() => import("./components/skeleton/EmployerDatabaseAccess/ViewDatabase"));
const DataBaseThanksCard = lazy(() => import("./components/skeleton/EmployerDatabaseAccess/DataBaseThanksCard"));
const TrialViewDatabaseAccess = lazy(() => import("./components/skeleton/EmployerDatabaseAccess/TrialViewDatabaseAccess"));
const HelpForJobseeker = lazy(() => import("./components/admin-panel/admin-components/HelpForJobseeker"));
const SearchPage2 = lazy(() => import("./components/Landingpage/Searchpage/SearchPage2"));

export const CurrentStateContext = createContext("");

// Lightweight loading component for lazy route fallback
const PageLoader = () => (
  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", backgroundColor: "#f8f9fa" }}>
    <div style={{ width: "40px", height: "40px", border: "4px solid #00E785", borderTop: "4px solid transparent", borderRadius: "50%", animation: "spin 0.8s linear infinite" }} />
    <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
  </div>
);

function App() {
  const axiosData = useAxios();
  const lang = sessionStorage.getItem("lang");
  const langCheck = lang === null ? "en" : lang;

  useEffect(() => {
    sessionStorage.setItem("lang", langCheck);
  }, [langCheck]);

  const [languagetranslator, setlanguagetranslator] = useState(lang ? lang : "en");

  const theme = useTheme();
  const customBreakpoints = {
    isMobile: useMediaQuery(theme.breakpoints.down("sm")),
    isMobileDown: useMediaQuery(theme.breakpoints.down(600)),
    isMobile350Down: useMediaQuery(theme.breakpoints.down(350)),
    isDeviceDown: useMediaQuery(theme.breakpoints.down("md")),
    isIpadPro: useMediaQuery("(max-width: 1024px)"),
    isIpadPro12_9_Landscape: useMediaQuery(
      "(min-width: 1300px) and (max-width: 1400px) and (min-height: 1000px) and (max-height: 1100px)"
    ),
  };

  const [getAdminSetting, setGetAdminSetting] = useState({});
  const [checked, setChecked] = useState({
    checked0: null,
    checked1: null,
    checked2: null,
    checked3: null,
    checked4: null,
    checked5: null,
    checked6: null,
  });

  const getAdminSettingData = async () => {
    try {
      const adminSet = await axiosData.get("application");
      const { data } = adminSet;
      if (data && data[0]) {
        setGetAdminSetting(data[0]);
        setChecked((prev) => ({
          ...prev,
          checked0: data[0].jobSeekerApproval,
          checked1: data[0].employerApproval,
          checked2: data[0].helpforjobseekerApproval,
          checked3: data[0].mentorApproval,
          checked4: data[0].needSupportApproval,
          checked5: data[0].verifierApproval,
          checked6: data[0].servicesProviderApproval,
        }));
      }
    } catch (err) {
      console.error(err);
    }
  };

  const getFunction = useMemo(() => ({ myFunction: getAdminSettingData }), []);

  useEffect(() => {
    getAdminSettingData();
  }, []);

  const baseUrl = axiosData.defaults.baseURL;

  // Memoize context value to prevent re-rendering the entire tree on unrelated state changes
  const contextValue = useMemo(
    () => ({
      languagetranslator,
      getAdminSetting,
      getFunction,
      checked,
      baseUrl,
      axiosData,
      customBreakpoints,
    }),
    [languagetranslator, getAdminSetting, getFunction, checked, baseUrl, axiosData, customBreakpoints]
  );

  return (
    <CurrentStateContext.Provider value={contextValue}>
      <React.Fragment>
        <BrowserRouter>
          <SeoHelmet />
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route
                path={ROUTINGDATA.LAND}
                element={<LandingPage setlanguagetranslator={setlanguagetranslator} />}
              >
                <Route path={ROUTINGDATA.LANDPAGECONTECT} element={<Landingpagecontext />} />
                <Route path={ROUTINGDATA.LANDPAGECONTACTUS} element={<LandingpageContactus />} />
                <Route path={ROUTINGDATA.TERMSANDCONDITION} element={<TermsAndCondition />} />
                <Route path={ROUTINGDATA.PrivacyPolicy} element={<PrivacyPolicy />} />
                <Route path={ROUTINGDATA.PurchasePolicy} element={<PurchasePolicy />} />
                <Route path={ROUTINGDATA.RefundPolicy} element={<RefundPolicy />} />
                <Route path={ROUTINGDATA.DeliveryPolicy} element={<DeliveryPolicy />} />
                <Route path={ROUTINGDATA.PricingPolicy} element={<PricingPolicy />} />
              </Route>
              <Route path={ROUTINGDATA.LOGIN} element={<Login />} />
              <Route path={ROUTINGDATA.BECOMEAPARTNER} element={<BecomeAPartner />} />
              <Route path={ROUTINGDATA.BECOMEAINVESTOR} element={<BecomeAInvestor />} />
              <Route path={ROUTINGDATA.LOCAL_SERVICE_LOGIN} element={<LocalServiceLogin />} />
              <Route path={ROUTINGDATA.LOCAL_SERVICE_PANEL} element={<LocalServicePanel />} />
              <Route
                path="/searchpage"
                element={<Navigate to={"/" + ROUTINGDATA.MAIN + ROUTINGDATA.Searchpage2 + "/result"} replace />}
              />
              <Route
                path={ROUTINGDATA.MAIN}
                element={<Main setlanguagetranslator={setlanguagetranslator} />}
              >
                <Route path={ROUTINGDATA.POSTJOB} element={<PostJob />} />
                <Route path={ROUTINGDATA.AUDITING} element={<Auditing />} />
                <Route path={ROUTINGDATA.POSTEDJOB} element={<PostedJob />} />
                <Route path={ROUTINGDATA.BUYDATABASEACCESS} element={<BuyDatabaseAccess />} />
                <Route path={ROUTINGDATA.VIEWDATABASE} element={<ViewDatabase />} />
                <Route path={ROUTINGDATA.TRIALVIEWACCESS} element={<TrialViewDatabaseAccess />} />
                <Route path={ROUTINGDATA.DataBaseThanksCard} element={<DataBaseThanksCard />} />
                <Route path={ROUTINGDATA.SUBSCRIPTIONS} element={<Subscribe />} />
                <Route path={ROUTINGDATA.PAYMENTSUCCESS} element={<PaymentSuccess />} />
                <Route path={ROUTINGDATA.APPLIEDSEEKERS} element={<SeekersApplied />} />
                <Route path={ROUTINGDATA.SEEKERSAPPLIED} element={<AppliedSeekers />} />
                <Route path={ROUTINGDATA.JOBSEEK} element={<JobSeekerRegForm />} />
                <Route path={ROUTINGDATA.companies} element={<CompanyList />} />
                <Route path={ROUTINGDATA.company} element={<CompanyDetails />} />
                <Route path={ROUTINGDATA.EMPLOYERUPDATE} element={<EmployerUpdate />} />
                <Route path={ROUTINGDATA.ThankYou} element={<Thankyou />} />
                <Route path={ROUTINGDATA.ThankYouForLocal} element={<ThankYouPageForLocal />} />
                <Route path={ROUTINGDATA.PageNotFound} element={<PageNotFound />} />
                <Route path={ROUTINGDATA.JOBPROVIDER} element={<Employer />} />
                <Route path={ROUTINGDATA.VOLUNTEER} element={<Volunteer />} />
                <Route path={ROUTINGDATA.MENTOR} element={<MentorRegistration />} />
                <Route path={ROUTINGDATA.MENTORABOUTUS} element={<MentorAboutUs />} />
                <Route path={ROUTINGDATA.MENTORUPDATE} element={<MentorUpdateForm />} />
                <Route path={ROUTINGDATA.MENTORProfile} element={<MentorAboutUs />} />
                <Route path={ROUTINGDATA.SEEKERNEEDSUPPORT} element={<NeedSupport />} />
                <Route path={ROUTINGDATA.BankDetails} element={<BankDetails />} />
                <Route path={ROUTINGDATA.RecommendedJob} element={<RecommendedJob />} />
                <Route path={ROUTINGDATA.ADVERTISEMENT} element={<Advertisement />} />
                <Route path={ROUTINGDATA.AdvertisePayment} element={<AdvertisePayment />} />
                <Route path={ROUTINGDATA.AppliedJobs} element={<AppliedJobs />} />
                <Route path={ROUTINGDATA.Searchpage} element={<SearchPage2 />} />
                <Route path={ROUTINGDATA.Searchpageforlocalservices} element={<Searchpageforlocalservices />} />
                <Route path={ROUTINGDATA.seekerProfile} element={<UpdateRegisterForm />} />
                <Route path={ROUTINGDATA.LOCALJOB} element={<LocalJobRegForm />} />
                <Route path={ROUTINGDATA.LOCAL_SERVICE_PROVIDER} element={<LocalServiceProviderForm />} />
                <Route path={ROUTINGDATA.LOCAL_SERVICES} element={<LocalServicesForm />} />
                <Route path={ROUTINGDATA.SERVICESUBSCRIPTIONS} element={<ServiceSubscription />} />
              </Route>

              <Route path={ROUTINGDATA.ForgotPW} element={<ForgotPassword />} />
              <Route path={ROUTINGDATA.ForgotPwOtp} element={<ForgotPW2 />} />
              <Route path={ROUTINGDATA.ChangePassword} element={<ChangePassword />} />
              <Route path={ROUTINGDATA.OtpforPassword} element={<OtpforPassword />} />

              {/* ADMIN */}
              <Route path={ROUTINGDATA.ADMINPANEL} element={<AdminPanel />}>
                <Route path={ROUTINGDATA.ADMINDASHBOARD} element={<Dashboard />} />
                <Route path={ROUTINGDATA.ADMINSETTINGS} element={<AdminSettings />}>
                  <Route path={ROUTINGDATA.ADMINAPPROVAL} element={<AdminApproval />} />
                  <Route path={ROUTINGDATA.ADMINEMPLOYERSETTING} element={<AdminEmployerSettings />} />
                  <Route path={ROUTINGDATA.ADMINIMAGEUPLOADSETTING} element={<ImageUploadSettings />} />
                  <Route path={ROUTINGDATA.AdminImageUpload} element={<AdminImageUpload />} />
                  <Route path={ROUTINGDATA.ADPAYMENTSETTING} element={<AdPaymentSettings />} />
                </Route>
                <Route path={ROUTINGDATA.ADMINSEEKERS} element={<SeekerData />} />
                <Route path={ROUTINGDATA.ADMINSERVICEPROVIDER} element={<ServiceProvider />} />
                <Route path="user" element={<UserData />} />
                <Route path={ROUTINGDATA.ADMINEMPLOYER} element={<EmployerData />} />
                <Route path={ROUTINGDATA.ADMINVOLUNTEER} element={<VolunteerData />} />
                <Route path={ROUTINGDATA.ADMINHELPFORJS} element={<HelpForJobseeker />} />
                <Route path={ROUTINGDATA.ADMINMENTOR} element={<MentorAdminData />} />
                <Route path={ROUTINGDATA.ADMINPARTNER} element={<AdminPartners />} />
                <Route path={ROUTINGDATA.ADMININVESTOR} element={<AdminInvestors />}>
                  <Route path={ROUTINGDATA.BECOMEAINVESTOR} element={<BecomeAInvestor />} />
                </Route>
                <Route path={ROUTINGDATA.ADMINMENTORABOUTUS} element={<MentorAboutUs />} />
                <Route path={ROUTINGDATA.ADVERTISEMENTSETTING} element={<AdminAdvertisementSettings />} />
                <Route path={ROUTINGDATA.PAYMENTVENDORS} element={<PaymentVendors />} />
                <Route path={ROUTINGDATA.ADMINNeedSupport} element={<SeekerNeedSupport />} />
                <Route path={ROUTINGDATA.ADMINSeekerFullFamilyDetails} element={<FullFamilyDetails />} />
                <Route path={ROUTINGDATA.ADMINSeekerVelaivendumSupport} element={<SeekerVelaivendumSupport />} />
                <Route path={ROUTINGDATA.fieldVerifiyCompletedFullDetails} element={<FullFamilyDetails />} />
                <Route path={ROUTINGDATA.ADMINALLJOBS} element={<AdminAllJobs />} />
              </Route>

              {/* MP CONSTITUENCY */}
              <Route path={ROUTINGDATA.MPConstituency} element={<MPconstituencyPanel />}>
                <Route path={ROUTINGDATA.MPDASHBOARD} element={<MPDashboard />} />
                <Route path={ROUTINGDATA.MP_ALL_DATA} element={<MPAllData />} />
                <Route path={ROUTINGDATA.MP_NEEDSUPPORT} element={<MPNeedSupport />} />
                <Route path={ROUTINGDATA.MP_SHORTLISTED} element={<MPShortList />} />
                <Route path={ROUTINGDATA.MP_Shortlisted_fullDetails} element={<VerifierFullDetails />} />
                <Route path={ROUTINGDATA.MP_MLAComponent} element={<MLAconstituency1 />} />
                <Route path={ROUTINGDATA.MP_MLAneedSupport} element={<MPMLAneedSupport />} />
                <Route path={ROUTINGDATA.MP_MLAShortlisted} element={<MPMLAShortList />} />
                <Route path={ROUTINGDATA.MP_MLAfullDetais} element={<VerifierFullDetails />} />
                <Route path={ROUTINGDATA.MP_MLAShortlisted_fullDetails} element={<VerifierFullDetails />} />
                <Route path={ROUTINGDATA.MP_MLASupported} element={<MPMLAsupported />} />
                <Route path={ROUTINGDATA.MP_MLASupported_fullDetails} element={<VerifierFullDetails />} />
                <Route path={ROUTINGDATA.MP_Supported} element={<MPsupported />} />
                <Route path={ROUTINGDATA.MP_Supported_fullDetails} element={<VerifierFullDetails />} />
              </Route>

              {/* MLA CONSTITUENCY */}
              <Route path={ROUTINGDATA.MLAconstituency} element={<MLAconsitiuencyPanel />}>
                <Route path={ROUTINGDATA.MLAdashboard} element={<MLAdashboard />} />
                <Route path={ROUTINGDATA.MLASeeker} element={<MLASeekers />} />
                <Route path={ROUTINGDATA.MLAneedSupport} element={<MLAneedSupport />} />
                <Route path={ROUTINGDATA.MLAShortlisted} element={<MLAneedSupport />} />
                <Route path={ROUTINGDATA.MLAfulDetails} element={<VerifierFullDetails />} />
                <Route path={ROUTINGDATA.MLAShortlisted_fullDetails} element={<VerifierFullDetails />} />
                <Route path={ROUTINGDATA.MLASupported} element={<MLAsupported />} />
                <Route path={ROUTINGDATA.MLASupported_fullDetails} element={<VerifierFullDetails />} />
              </Route>

              {/* VERIFIER PANEL */}
              <Route path={ROUTINGDATA.verifier} element={<VerifierPanel />}>
                <Route path={ROUTINGDATA.verifierDash} element={<VerifierDashboard />} />
                <Route path={ROUTINGDATA.verifierFullDetails} element={<VerifierFullDetails />} />
              </Route>

              {/* VOLUNTEER */}
              <Route path={ROUTINGDATA.helpforjobseekerPanel} element={<VolunteerPanel />}>
                <Route path={ROUTINGDATA.helpforjobseekerDashboard} element={<VolunteerDashboard />} />
                <Route path={ROUTINGDATA.helpforjobseekerAllData} element={<VolunteerAllDetails />} />
                <Route path={ROUTINGDATA.helpforjobseekerNeedsupport} element={<VolunteerNeedSupport />} />
                <Route path={ROUTINGDATA.helpforjobseekerShortlisted} element={<VolunteerShortList />} />
                <Route path={ROUTINGDATA.helpforjobseekerFullDetails} element={<VerifierFullDetails />} />
                <Route path={ROUTINGDATA.helpforjobseekerShortlisted_fullDetails} element={<VerifierFullDetails />} />
                <Route path={ROUTINGDATA.helpforjobseekerSupported} element={<VolunteerSupported />} />
                <Route path={ROUTINGDATA.helpforjobseekerSupported_fullDetails} element={<VerifierFullDetails />} />
              </Route>

              <Route path={ROUTINGDATA.LOCALPROVIDERPANEL} element={<ProviderPanel />}>
                <Route path={ROUTINGDATA.LOCALPROVIDERDASHBOARD} element={<ProviderDashboard />} />
              </Route>
              <Route path={ROUTINGDATA.PARTNERPANEL} element={<PartnerPanel />}>
                <Route path={ROUTINGDATA.PARTNERDASH} element={<PartnerDashboard />} />
              </Route>
              <Route path={ROUTINGDATA.INVESTORPANEL} element={<InvestorPanel />}>
                <Route path={ROUTINGDATA.INVESTORDASH} element={<InvestorDashboard />} />
                <Route path={ROUTINGDATA.INVESTORALLOCATEDPINCODES} element={<InvestorAllocatedPincodes />} />
                <Route path={ROUTINGDATA.INVESTORCREATEPINCODEFRANCHISER} element={<InvestorCreatePincodeFranchiser />} />
                <Route path={ROUTINGDATA.INVESTORPINCODEWISEPAYMENT} element={<InvestorPincodewisePayment />} />
                <Route path={ROUTINGDATA.INVESTORTODAYCOLLECTIONREPORT} element={<InvestorTodayCollectionReport />} />
                <Route path={ROUTINGDATA.INVESTORMASTERMYLEADS} element={<InvestorMasterMyLeads />} />
                <Route path={ROUTINGDATA.INVESTORMASTERMYCOUSTOMER} element={<InvestorMasterMyCoustomer />} />
                <Route path={ROUTINGDATA.INVESTORMASTERMYEMPLOYER} element={<InvestorMyEmployer />} />
              </Route>
            </Routes>
          </Suspense>
        </BrowserRouter>
      </React.Fragment>
    </CurrentStateContext.Provider>
  );
}

export default App;
